module.exports = __webpack_public_path__ + "static/media/file-chart-line.36807fab.svg";